import { render, staticRenderFns } from "./iconografia-details.vue?vue&type=template&id=48e2b7fe&"
import script from "./iconografia-details.vue.ts?vue&type=script&lang=ts&"
export * from "./iconografia-details.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports